import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ROOT_URL } from '../../api/ApiConfig';// Assuming react-toastify is installed and configured
// Assuming BASE_URL is imported similarly to ROOT_URL

export const getAllExternalKbCategories = createAsyncThunk(
  'kbCategory/getAllExternalKbCategories',
  async ({ businessName, group_id }, { getState, rejectWithValue }) => {
    try {
      const url = `${ROOT_URL}/kb/categories/external/${businessName}`;
      const response = await axios.get(url, {
        params: group_id ? { group_id } : undefined,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching featured articles:', error);
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch featured articles'
      );
    }
  }
);


const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
};

const getAllExternalKbCategoriesSlice = createSlice({
  name: 'getAllExternalKbCategories',
  initialState,
  reducers: {
    resetGetAllExternalKbCategoriesState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllExternalKbCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getAllExternalKbCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;


      })
      .addCase(getAllExternalKbCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        toast.error(action.payload?.message);
      });
  }
});

export const { resetGetAllExternalKbCategoriesState } = getAllExternalKbCategoriesSlice.actions;
export default getAllExternalKbCategoriesSlice.reducer;